"use client";

import { PlainMessage } from "@bufbuild/protobuf";
import {
  EventSeries,
  Price as PriceType,
  Section,
} from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { TicketControls } from "~/components/TicketControls";
import { moneyToCurrency, cn } from "~/lib/utils";
import { EventOrBundle } from "~/lib/definitions";
import { UnlockBadge } from "~/app/tickets/[eventId]/_components/UnlockBadge";

type Props = {
  section: PlainMessage<Section>;
  price: PlainMessage<PriceType>;
  eventOrBundle: EventOrBundle;
  series?: PlainMessage<EventSeries>;
  index: number;
  length: number;
  availability?: number;
};

export function Price(props: Props) {
  const price = moneyToCurrency(props.price.value);

  return (
    <div
      className={cn(
        "border-b-size-1 flex flex-col flex-nowrap gap-3 border-0 border-solid border-transparent bg-white py-2 pl-[10px] pr-[10px] md:pl-[34px] lg:gap-0",
        props.index < props.length - 1 && "border-b border-border",
      )}
      data-border={props.index < props.length - 1}
    >
      <div className="flex flex-row flex-wrap justify-between">
        <p className="mb-[15px] text-[14px] leading-[20px] text-text">
          <span className="flex flex-row gap-2">
            {props.price.isUnlocked && <UnlockBadge type="price" />}
            {props.price.name}
          </span>
          <br />
          <span
            className={cn(
              Number(props?.availability) <= 0 ? "grid-cols-2" : "grid-cols-1",
              "grid items-center gap-12",
            )}
          >
            <span className="text-[16px] font-bold leading-[22px] text-text">
              {price}
            </span>
          </span>
        </p>

        <div className="items-center">
          <TicketControls
            section={props.section}
            price={props.price}
            eventOrBundle={props.eventOrBundle}
            series={props.series}
            availability={props.availability}
            sumAmounts
          />
        </div>
      </div>
      <p className="max-w-full text-[12px] leading-[20px] text-gray-400">
        {props.price.description}
      </p>
    </div>
  );
}
